var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxesLight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.625 14.375V18.125",
    stroke: "#657B90",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 14.375V18.125",
    stroke: "#657B90",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.375 5.625V9.375",
    stroke: "#657B90",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.125 7.425C8.125 6.43089 8.93089 5.625 9.925 5.625H18.825C19.8191 5.625 20.625 6.43089 20.625 7.425V14.375H9.925C8.93089 14.375 8.125 13.5691 8.125 12.575V7.425Z",
    stroke: "#657B90"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 16.175C5.625 15.1809 6.43089 14.375 7.425 14.375H15.625V24.375H7.425C6.43089 24.375 5.625 23.5691 5.625 22.575V16.175Z",
    stroke: "#657B90"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 14.375H23.825C24.8191 14.375 25.625 15.1809 25.625 16.175V22.575C25.625 23.5691 24.8191 24.375 23.825 24.375H15.625V14.375Z",
    stroke: "#657B90"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxesLight);
export default __webpack_public_path__ + "static/media/Boxes_light.8306a27e91de02eaf6adc815f850f6f7.svg";
export { ForwardRef as ReactComponent };